// extracted by mini-css-extract-plugin
export default {"content":"ModalCrearProfesor_content__IxCC9","intro":"ModalCrearProfesor_intro__w6IKk","input":"ModalCrearProfesor_input__j+9uk","rol":"ModalCrearProfesor_rol__jkspf"};